import { render, staticRenderFns } from "./AbsenceTypeList.vue?vue&type=template&id=72213c09"
import script from "./AbsenceTypeList.vue?vue&type=script&lang=js"
export * from "./AbsenceTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports